import { gql } from '@apollo/client';

export const CREATE_GREASE_TRAP = gql`
  mutation CreateGreaseTrap(
    $vendor_id: ID!
    $driver_id: ID!
    $truck_id: ID!
    $location_id: ID!
    $gross_pounds: Float!
    $gallons_grease_received: Float!
    $traceability: Boolean
    $registered_by: ID!
    $driver_signature: Upload
  ) {
    createGreaseTrap(
      vendor_id: $vendor_id
      driver_id: $driver_id
      truck_id: $truck_id
      location_id: $location_id
      gross_pounds: $gross_pounds
      gallons_grease_received: $gallons_grease_received
      traceability: $traceability
      registered_by: $registered_by
      driver_signature: $driver_signature
    ) {
      id
    }
  }
`;
